import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';

export const logOwaFluidOneDriveError = (
    performanceDatapoint: PerformanceDatapoint,
    errorMessage: string
) => {
    if (performanceDatapoint && !performanceDatapoint.hasEnded) {
        performanceDatapoint.endWithError(
            DatapointStatus.RequestNotComplete,
            new Error(errorMessage)
        );
    }
};
